import { render } from "./App.vue?vue&type=template&id=4f05065a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4f05065a&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vue-ghibli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__